export default "__VITE_ASSET__BKM2ildn__"